<template>
  <v-main>
    <v-container class="fill-height" fluid>
      <v-row class="fill-height" justify="start">
        <v-col cols="12">
          <v-card color="#1976d2">
            <v-card-title primary-title class="white--text">
              <div>
                <h3 class="headline mb-2">
                  Статистика по мероприятиям
                </h3>
              </div>
            </v-card-title>
          </v-card>

          <v-card>
            <v-col cols="12">
              <div class="text-center">
                <v-dialog
                  v-model="loading"
                  persistent
                  width="300">
                  <v-card
                    color="primary"
                    dark>
                    <v-card-text>
                      Загружаются данные отчета
                      <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0" />
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </div>
              <v-row align="center" justify="center">
                <BaseDatePicker :value="lowestDate" label="С" @dateUpdated="dateLowerUpdated" />
                <BaseDatePicker :value="highestDate" label="По" @dateUpdated="dateHigherUpdated" />
                <v-btn color="primary" class="mb-2" @click="submitSearch">
                  Поиск
                </v-btn>
              </v-row>
            </v-col>

            <ReportTable :data="tableData"
                         :headers="headers"
                         :loading="loading"
                         :sortable="false"
                         :is-searchable="true"
                         :is-dragable="false"
                         :table-name="'Статистика по мероприятиям('+lowestDate+' по '+highestDate+')'" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from 'axios'
import ReportTable from '../ReportTable'
import BaseDatePicker from '../../base/BaseDatePicker'
import {authHeader} from '../../../_helpers/auth-header'
import {mapState} from 'vuex'

export default {
  name: "ReportAges",
  components: {
    BaseDatePicker,
    ReportTable
  },

  props: {
    report: {
      type: String,
      default:''
    }
  },
  data () {
    return {
      lowestDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substr(0, 10),
      highestDate: new Date().toISOString().substr(0, 10),
      loading: false,
      tableData: [],
      headers: [
        {text: 'Название', value: 'name', align: 'left', sortable: true},
        {text: 'Спикер', value: 'speaker', align: 'left', sortable: true},
        {text: 'Посетило', value: 'attented_num', align: 'left', sortable: true},
        {text: 'Посетило новых', value: 'attented_new', align: 'left', sortable: true}
        ]
    }
  },
  computed: mapState({
    places: state => state.tableData.places
  }),
  methods: {
    dateLowerUpdated (newVal) {
      this.lowestDate = newVal
    },
    dateHigherUpdated (newVal) {
      this.highestDate = newVal
    },
    submitSearch () {
      this.loading = true
      const requestOptions = {
        method: 'GET',
        headers: authHeader()
      }

      axios({
        url: this.$store.state.tableData.backend + '/report/seminars_attend',
        headers: requestOptions['headers'],
        method: 'post',
        data: {
          lowestDate: this.lowestDate,
          highestDate: this.highestDate
        }

      }).then((response) => {
        this.loading = false
        this.tableData = response.data
      }).catch((error) => {
        throw new Error(`You can't load the data`)
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/reports/pages/ReportSeminarsAttenders.vue